var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-fo-list"},[_c('div',[_vm._v(_vm._s(_vm.message))]),_c('b-button',_vm._g({staticClass:"toast-fo-list__btn"},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }